import ScrollPane from './_scroll-pane.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Image from './_image.js'

export default {
  name: 'RaceExplanationPane',
  values: {
    items: {
      default: [
        'RESULT',
        'RACE_OFF',
        'BEST_ODDS',
        'PRICED',
      ],
      greyhound_racing: [
        'RESULT',
        'RACE_OFF',
        'PRICED',
      ],
    },
    scrollPane: {
      configSet: ScrollPane,
      configValues: {
        display: 'flex',
        direction: 'x',
      },
    },
    explanationItemsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          justifyContent: 'flex-end',
          padding: '8px',
          flexShrink: 0,
        },
      },
    },
    explanationItem: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexGrow: 0,
        },
      },
    },
    explanationText: {
      configSet: Text,
      configValues: {
        truncate: true,
        ellipsisOnLineNumber: 1,
      },
    },
    resultRaceIcon: {
      configSet: Image,
      configValues: {
        src: 'post',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    raceOffIcon: {
      configSet: Image,
      configValues: {
        src: 'start-time',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    bestOddsRaceIcon: {
      configSet: Image,
      configValues: {
        src: 'racing-bestodds',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    pricedRaceIcon: {
      configSet: Image,
      configValues: {
        src: 'racing-price',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
